export const getBudget = () => {
    return {
        "budgetValues": {
            "JANUARY": 0,
            "FEBRUARY": 0,
            "MARCH": 0,
            "APRIL": 0,
            "MAY": 0,
            "JUNE": 0,
            "JULY": 0,
            "AUGUST": 0,
            "SEPTEMBER": 0,
            "OCTOBER": 0,
            "NOVEMBER": 0,
            "DECEMBER": 0
        },
        "forecastValues": {
            "JANUARY": 0,
            "FEBRUARY": 0,
            "MARCH": 0,
            "APRIL": 0,
            "MAY": 0,
            "JUNE": 0,
            "JULY": 0,
            "AUGUST": 0,
            "SEPTEMBER": 0,
            "OCTOBER": 0,
            "NOVEMBER": 0,
            "DECEMBER": 0
        },
        "actualValues": {
            "JANUARY": 0,
            "FEBRUARY": 0,
            "MARCH": 0,
            "APRIL": 0,
            "MAY": 0,
            "JUNE": 0,
            "JULY": 0,
            "AUGUST": 0,
            "SEPTEMBER": 0,
            "OCTOBER": 0,
            "NOVEMBER": 0,
            "DECEMBER": 0
        }
    }
}
